import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { navLinks } from '../../../routes/links';
import { path } from '../../../routes/paths';
import Logo from '../logo/Logo';
import LanguageSelect from '../Select/LanguageSelect.component';
import {
  NavContainer,
  Content,
  LinkTab,
  StyledNavButton,
  navbarProps
} from './Navbar.styles';

const Navbar = ({ activeTab }: navbarProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [popup, setPopup] = useState<Window | null>(null);

  const handleOpenMarketPopup = () => {
    if (popup == null || popup.closed) {
      setPopup(window.open(t('market-on-canva-url'), 't54canvas', 'scrollbars=yes,top=200,left=200,width=800,height=800'));
    } else {
      popup?.focus();
    }
  }
  useEffect(() => {
    setActiveIndex(navLinks.findIndex(l => l.url === location.pathname));
  }, [location]);

  return (
    <NavContainer>
      <Content>
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <Logo width={95} height={28} />
          <div>
            {navLinks.map((link) => (
              <LinkTab
				        key={link.id}
                activeTab={activeIndex === link.id}
                onClick={() => {
                  setActiveIndex(link.id);
                  if (link.url === path.MARKET) {
                    handleOpenMarketPopup();
                  }
                }}
              >
                <Link style={{ textTransform: 'none', textDecoration: 'none', color: activeIndex === link.id ? '#33f' : '#333' }} to={link.url}>
                  {t(link.label)}
                </Link>
              </LinkTab>
            ))}
          </div>
        </div>
        <div
          style={{
            width: '60%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }}
        >
          <StyledNavButton
            text={t('sign-in')}
            bgColor="rgba(134, 184, 23, 1)"
            width={20}
            onClick={() => navigate(path.SIGNIN)}
          />
          <StyledNavButton
            text={t('get-started')}
            bgColor="rgba(230, 63, 7, 1)"
            width={23}
          />
          <LanguageSelect text="EN" dropdownListStyle={{ background: '#eee' }} />
        </div>
      </Content>
    </NavContainer>
  );
};

export default Navbar;
